
// 취약점진단통계
export const summaryColumnData = [
    {
        title: '분류',
        align: 'center',
        colSpan: 2,
        rowSpan: 2,
        children: [
            {
                title: '코드',
                dataIndex: 'code',
                key: 'code',
                width: '70px',
                align: 'center',
                colSpan:0,
            },
            {
                title: '항목',
                dataIndex: 'name',
                key: 'name',
                width: '150px',
                align: 'center',
                colSpan : 0,
                ellipsis : true,
            }, 
        ]
    },
    {
        title: '진단결과',
        align: 'center',
        children: [
            {
                title: '전체항목',
                dataIndex: 'total',
                key: 'total',
                width: '70px',
                align: 'center',
            },
            {
                title: '진단항목',
                dataIndex: 'check',
                key: 'check',
                width: '70px',
                align: 'center',
            },
            {
                title: '양호',
                dataIndex: 'Y',
                key: 'Y',
                width: '70px',
                align: 'center',
            },
            {
                title: '취약',
                dataIndex: 'N',
                key: 'N',
                width: '70px',
                align: 'center',
            },
            {
                title: '부분이행',
                dataIndex: 'P',
                key: 'P',
                width: '70px',
                align: 'center',
            },
            {
                title: '해당없음',
                dataIndex: 'NA',
                key: 'NA',
                width: '70px',
                align: 'center',
            },
        ]
    },
    {
        title: '중요도점수',
        align: 'center',
        children: [
            {
                title: '전체점수',
                dataIndex: 'total_score',
                key: 'total_score',
                width: '70px',
                align: 'center',
            },
            {
                title: '평가점수',
                dataIndex: 'eval_score',
                key: 'eval_score',
                width: '70px',
                align: 'center',
            },
            {
                title: '보안수준',
                key: 'level',
                width: '70px',
                align: 'center',
                render: (_ , rowData ) => {
                    return (
                        <>
                            {rowData.level}%
                        </>
                    );
                },
            }
        ]
    },
];
